import { IonCol } from "@ionic/react";
import { useCallback, useState } from "react";
import FilterList, { stringFilter } from "../../../FilterList/FilterList";
import { FilterState, StingFilterType } from "../../../FilterList/types";

import { Locale } from "../../../../setup/locale";
import List from "../../../List/List";
import { pageRange } from "../../../List/Pagination/pagerange";
import { HeaderOption } from "../../../List/types";
import { useNamedRoutes } from "../../../NamedRoutes";
import { useIsMobile } from "../../../Responsive";
import TypeaheadString from "../../../TypeAhead/TypeAheadString";
import { getList } from "../../../TypeAhead/helper";
import { Filter } from "../types/reportTypes";
import { DisplayDeviceProps } from "./types";



type PersistentFilter = Filter<{}> & FilterState;


const header: HeaderOption<Locale, any>[] = [
    {
        title: '[REACT_DISPLAY_DEVICE_TYPE]', key: 'deviceType', both: true
    },
    {
        title: '[REACT_CONTROL_PANEL_TYPE]', key: 'panelType', both: true
    },
    {
        title: '[REACT_CONTROL_PANEL_NUMBER]', key: 'panelNumber', both: true
    },
    {
        title: '[REACT_CONNECTED_TO]', key: 'connectedTo', breakpoint: 1200, up: true
    },
    {
        title: 'COM_INSTALLER_HEADING_LOCATION', key: 'location', breakpoint: 1200, up: true
    },
    {
        title: '[REACT_INTERFACE_TYPE]', key: 'interfaceType', breakpoint: 1200, up: true
    },
    {
        title: '[REACT_CONNECTIONS]', key: 'connections', breakpoint: 1200, up: true
    },
    {
        title: 'COM_CONTACT_ADDRESS', key: 'address', breakpoint: 1200, up: true
    },

];

const DisplayDevice: React.FC<DisplayDeviceProps> = ({
    system,
    filter,
    onIsOpen,
    onFilterActive
}) =>
{


    const { generate } = useNamedRoutes();
    const mobileView = useIsMobile();


    const data = [
        {
            link: generate('systems'),
            deviceType: system.systemType,
            panelType: system.id,
            panelNumber: system.name,
            connectedTo: "",
            location: "",
            interfaceType: "",
            connections: [],
            address: "Wiegelestr.",
        },

    ];


    const [list, setList] = useState<any[] | null>(data);

    type Filter = {
        deviceType?: StingFilterType,
        panelType?: StingFilterType,
        panelNumber?: StingFilterType,
        connectedTo?: StingFilterType,
        location?: StingFilterType,
        interfaceType?: StingFilterType,
        connections?: StingFilterType,
        address?: StingFilterType,
    };

    const [currentState, setState] = useState<Filter & FilterState>({});


    const [currentRowLimit, setCurrentRowLimit] = useState<number>(pageRange[1]);

    const onIsFilterOpen = useCallback((state: boolean) => { onIsOpen && onIsOpen(state, "main"); }, [onIsOpen]);
    const onIsDetailFilterOpen = useCallback((isDetailOpen: boolean) => onIsOpen && onIsOpen(isDetailOpen, "detail"), [onIsOpen]);
    //const onResetFilter = useCallback(() => setState(() => {}), [setState]);

    return <>
        <FilterList
            isOpen={filter?.isFilterOpen || false}
            isDetailsOpen={filter?.isDetailOpen || false}
            onIsOpen={onIsFilterOpen}
            onDetailOpen={onIsDetailFilterOpen}
            //onReset={onResetFilter}
            noPrint
            details={<>
                <IonCol>
                    <TypeaheadString
                        id="deviceType"
                        onFilter={async (value: string) =>
                        {
                            setState({ ...currentState, deviceType: (a: string, b: string): boolean => stringFilter(a, value) });
                            const list = await getList(data, 'deviceType');
                            return list;
                        }}
                        disabled={!data.length}
                        text={"[REACT_DISPLAY_DEVICE_TYPE]"}
                    />

                </IonCol>
                <IonCol></IonCol>
                <IonCol></IonCol>
                <IonCol></IonCol>
            </>}
        >
        </FilterList >

        <List
            rows={list}
            maxHeight={mobileView ? "86vh" : "58vh"}
            headers={header}

        />
    </>;
};

export default DisplayDevice;
